import {
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  Button,
  Descriptions,
  Empty,
  Popconfirm,
  Space,
  Table,
  Tag,
  Tooltip,
  Typography,
  message,
} from "antd";
import { parseOutputFormats } from "./OutputFormatPicker";
const { Text } = Typography;

const BACKGROUND_LABELS = {
  Transparent: "Trong suốt",
  "Solid Color": "Màu đặc",
  White: "Nền trắng",
  Custom: "Tùy chỉnh",
};

export default function RequirementTable({
  specs = [],
  canEdit,
  canDelete,
  onEdit,
  onDelete,
}) {
  const copy = async (text) => {
    await navigator.clipboard.writeText(text);
    message.success("Đã sao chép kích thước");
  };
  const columns = [
    {
      title: "Vị trí in",
      dataIndex: "areaName",
      key: "areaName",
      width: "28%",
      render: (value, r) => {
        const attributes = Object.entries(r.customAttributes || {});
        return (
          <>
            <Text strong>{value}</Text>
            {attributes.length > 0 && (
              <Descriptions
                className="specstudio-spec-attributes"
                size="small"
                column={1}
                items={attributes.map(([key, attr]) => ({
                  key,
                  label: key,
                  children: String(attr),
                }))}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Kích thước & DPI",
      key: "size",
      render: (_, r) => {
        const size =
          r.width && r.height ? `${r.width} × ${r.height} ${r.unit}` : null;
        return (
          <Space direction="vertical" size={2}>
            {size ? (
              <Space size={4}>
                <Text code>{size}</Text>
                <Tooltip title="Copy kích thước">
                  <Button
                    type="text"
                    size="small"
                    icon={<CopyOutlined />}
                    onClick={() => copy(size)}
                  />
                </Tooltip>
              </Space>
            ) : (
              <Text type="secondary">Chưa có kích thước</Text>
            )}
            <Text type="secondary">{r.dpi ? `${r.dpi} DPI` : "—"}</Text>
          </Space>
        );
      },
    },
    {
      title: "Định dạng & nền",
      key: "format",
      render: (_, r) => {
        const formats = parseOutputFormats(r.outputFormat);
        return (
          <Space direction="vertical" size={4}>
            {formats.length ? (
              <Space size={[4, 4]} wrap>
                {formats.map((format) => (
                  <Tag key={format} color="blue" bordered={false}>
                    {format}
                  </Tag>
                ))}
              </Space>
            ) : (
              <Text type="secondary">—</Text>
            )}
            {r.backgroundType && (
              <Text type="secondary">
                {BACKGROUND_LABELS[r.backgroundType] || r.backgroundType}
              </Text>
            )}
          </Space>
        );
      },
    },
    {
      title: "Template resource",
      dataIndex: "templateFileUrl",
      key: "template",
      render: (v) =>
        v ? (
          <Button
            type="link"
            href={v}
            target="_blank"
            rel="noreferrer"
            icon={<DownloadOutlined />}
            style={{ paddingInline: 0 }}
          >
            Tải file template
          </Button>
        ) : (
          <Text type="secondary">Chưa có template</Text>
        ),
    },
    {
      title: "",
      key: "actions",
      width: 90,
      render: (_, r) => (
        <Space size={0}>
          {canEdit && (
            <Tooltip title="Sửa vùng in">
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => onEdit(r)}
              />
            </Tooltip>
          )}
          {canDelete && (
            <Popconfirm
              title={`Xóa vùng in ${r.areaName}?`}
              okText="Xóa"
              cancelText="Hủy"
              okButtonProps={{ danger: true }}
              onConfirm={() => onDelete(r.id)}
            >
              <Button danger type="text" icon={<DeleteOutlined />} />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
  return (
    <Table
      className="specstudio-table specstudio-spec-table"
      rowKey="id"
      size="middle"
      columns={columns}
      dataSource={specs}
      pagination={false}
      scroll={{ x: 760 }}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Chưa có vùng in"
          />
        ),
      }}
    />
  );
}
